module.exports = __webpack_public_path__ + "static/media/logo3.ad3bfd3c.png";